import React from "react";
import { CheckIcon, GiftIcon, HeartIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/bonuses";
export function Bonuses() {
  return <section className="bg-sun-soft px-2 py-16 sm:px-4 sm:py-20" data-id="element-113" data-mp="1clfs4w45jpm8">
      <div className="mx-auto max-w-4xl" data-id="element-114" data-mp="18km6k9e6mmwi">
        <div className="px-2" data-id="element-115" data-mp="18hhw4ua4iuxe">
          <SectionHeading eyebrow="Your 5 exclusive bonuses" title="Because Practical Communication Support Requires More Than Theory." subtitle="Alongside your six core volumes, you’ll receive five specialized resources designed to make planning, preparation, and documentation easier." data-id="element-116" data-mp="259lipzhw08tz" />
        </div>

        <div className="mt-10 space-y-6" data-id="element-117" data-mp="1r9sse5a9vumj">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_8px_28px_rgba(14,37,87,0.08)]" data-id="element-118" data-mp="kv1orttrlvot">
              <img src={b.image} alt={`${b.title} mockup`} className="block aspect-[4/3] w-full object-cover" data-id="element-119" data-mp="ftm0lswaj927" />
              <div className="px-4 pb-6 pt-5 sm:px-8" data-id="element-120" data-mp="1erkfd7i0woa5">
                <div className="flex flex-wrap items-center gap-2" data-id="element-121" data-mp="1jrov2vb3xezb">
                  <span className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1 text-sm font-black uppercase tracking-wide" style={{
                backgroundColor: b.tint,
                color: b.ink
              }} data-id="element-122" data-mp="15t8meytopeej">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="w1m6wqabct5z" />
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-extrabold text-ink/70" data-id="element-124" data-mp="10vqaczkdej2b">
                    Suggested Reference Value: <span className="line-through" data-id="element-125" data-mp="r42feoolujw3">{b.value}</span>{" "}
                    <span className="font-black text-cta" data-id="element-126" data-mp="r4c84k11b55h">— INCLUDED</span>
                  </span>
                </div>
                <h3 className="mt-3 text-balance text-2xl font-black leading-tight text-navy sm:text-3xl" data-id="element-127" data-mp="d6nn9c6yvy0f">{b.title}</h3>
                <p className="mt-2 text-lg font-extrabold leading-snug" style={{
              color: b.ink
            }} data-id="element-128" data-mp="2jsbkgutcak9b">
                  {b.subtitle}
                </p>
                <p className="mt-3 text-base font-semibold leading-relaxed text-ink/80" data-id="element-129" data-mp="2f0achl37ffp3">{b.description}</p>
                <p className="mt-5 text-sm font-black uppercase tracking-wide text-navy" data-id="element-130" data-mp="2b0hzmw6s2ndx">Includes:</p>
                <ul className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-131" data-mp="262zyhrz05cgh">
                  {b.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-132" data-mp="32pbkj784kotu">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{
                  backgroundColor: b.tint,
                  color: b.ink
                }} data-id="element-133" data-mp="2yr5lkldj3djh">
                        <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-134" data-mp="2otr3khbyigp2" />
                      </span>
                      <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-135" data-mp="1dchn83o4k4rz">{item}</span>
                    </li>)}
                </ul>
                <div className="mt-6 flex gap-3 rounded-2xl p-4" style={{
              backgroundColor: b.tint
            }} data-id="element-136" data-mp="13a44sfe4nj2x">
                  <HeartIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                color: b.ink
              }} aria-hidden="true" data-id="element-137" data-mp="187xdbf2wkp6d" />
                  <p className="text-[15px] font-semibold leading-relaxed text-ink" data-id="element-138" data-mp="1d4nt01aspir9">
                    <span className="font-black" style={{
                  color: b.ink
                }} data-id="element-139" data-mp="1hyryeg4exiq8">
                      Why you’ll love it:{" "}
                    </span>
                    {b.why}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-10 px-2 text-center" data-id="element-140" data-mp="1vyjhgv9sdpb3">
          <p className="text-balance text-2xl font-black uppercase leading-tight text-navy sm:text-3xl" data-id="element-141" data-mp="20wbe22ldlzlm">
            All five bonuses are included today.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-base font-semibold leading-relaxed text-ink/75" data-id="element-142" data-mp="1l1wng0rn6jr">
            These resources complement your six-volume collection and provide practical tools for organizing
            communication support across different environments.
          </p>
          <div className="mt-8" data-id="element-143" data-mp="1rzt2d7mswqqi">
            <CtaButton label="Yes! Give me all five bonuses" sub="Complete Collection · One-Time Payment of $27" data-id="element-144" data-mp="2603q41stdp7g" />
          </div>
        </div>
      </div>
    </section>;
}